export * from './ProductCardV2Footer';
